import { createBrowserHistory } from "history";
import ReactGA from 'react-ga4';

const history = createBrowserHistory();

const meta = document.querySelector('meta[name="nalgoo:analytics"]');

if (meta && meta.getAttribute('content')) {
	const trackingId = meta.getAttribute('content');

	ReactGA.initialize(trackingId);

	history.listen(location => {
		ReactGA.set({ page: location.pathname });
		ReactGA.pageview(location.pathname);
	});
}

export default history;
